var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgConnectionon = function SvgConnectionon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7803 5.28033C20.0732 4.98744 20.0732 4.51256 19.7803 4.21967C19.4874 3.92678 19.0126 3.92678 18.7197 4.21967L16.2739 6.66547C14.7027 5.59131 12.5409 5.75164 11.1461 7.14646L10.8461 7.44646C10.2642 8.02832 10.2642 8.97171 10.8461 9.55357L14.4461 13.1536C15.0279 13.7354 15.9713 13.7354 16.5532 13.1536L16.8532 12.8536C18.2479 11.4589 18.4083 9.29731 17.3345 7.7262L19.7803 5.28033ZM9.55393 10.8464C8.97207 10.2646 8.02869 10.2646 7.44682 10.8464L7.14683 11.1464C5.75213 12.5411 5.5917 14.7027 6.66554 16.2738L4.21967 18.7197C3.92678 19.0126 3.92678 19.4874 4.21967 19.7803C4.51256 20.0732 4.98744 20.0732 5.28033 19.7803L7.72613 17.3345C9.29728 18.4087 11.4591 18.2484 12.8539 16.8535L13.1539 16.5535C13.7358 15.9717 13.7358 15.0283 13.1539 14.4464L9.55393 10.8464Z",
    fill: "#52C41A"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConnectionon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/connectionon.2362b070.svg";
export { ForwardRef as ReactComponent };